var v1="<div class=\"content-wrap right\"><div class=\"title\">{{:: '_DASHBOARD.FAIRWAY_KEEP_COURSE' | translate }}&nbsp;<span class=\"small\"> {{:: '_DASHBOARD.RANKING' | translate }}</span></div><div ng-repeat=\"item in topFairwayHitCourses\" class=\"row\"><div class=\"column-value\"><div gnp-fairway-hit-chart=\"\" fairway-hit-data=\"::(item.rat_fairway_center * 100 | percentToFormattedString)\"></div></div><div class=\"column-content\"><div class=\"date\">{{ ::item.play_date }}</div><div class=\"desc\">{{ ::item.club_name }} {{ ::item.course_name }}</div></div></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/fairway-hit/fairway-hit.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/dashboard/fairway-hit/fairway-hit.jade
// module id = 553
// module chunks = 0